import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { updatePassword } from 'entities/Auth/api';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';
import { FunctionComponent } from 'react';
import { useMutation } from 'react-query';
import { ColorPalette } from 'shared/consts/colorPalette';
import { ChangeLanguage } from 'shared/ui/ChangeLanguage';
import { showErrorNotification } from 'shared/helpers/showErrorNotification';
import { FormContainer } from 'widgets/PersonalAccount/ui/Paper';
import { PasswordForm } from 'shared/ui/PasswordForm';
import { ChangePasswordValues } from 'shared/ui/PasswordForm/consts/validation';

export const ChangePassword: FunctionComponent = () => {
	const { t } = useTranslation();
	const { mutate, isLoading } = useMutation({ mutationFn: updatePassword });

	const handleSubmit = (values: ChangePasswordValues): void => {
		mutate(
			{ password: values.password, currentPassword: values.currentPassword },
			{
				onSuccess: () => {
					enqueueSnackbar({ message: t('shared_texts.success_update'), variant: 'success' });
				},
				onError: (err) => {
					showErrorNotification(err as AxiosError);
				},
			},
		);
	};

	return (
		<>
			<Typography variant={'h5'} color={ColorPalette.astronaut}>
				{t('personal_account.tab_3.title_2')}
			</Typography>
			<Box sx={{ position: 'absolute', top: '49px', right: '40px' }}>
				<ChangeLanguage />
			</Box>
			<FormContainer sx={{ marginTop: '34px', marginBottom: '36px' }}>
				<PasswordForm mode="update" onSubmit={handleSubmit} isLoading={isLoading} />
			</FormContainer>
		</>
	);
};
